import { ShieldCheck, Star, Globe } from "lucide-react";

const features = [
  {
    icon: <ShieldCheck className="w-10 h-10 text-blue-500" />,
    title: "Quality Guarantee",
    description: "100% Satisfaction",
  },
  {
    icon: <Star className="w-10 h-10 text-blue-500" />,
    title: "Premium Quality",
    description: "Certified Materials",
  },
  {
    icon: <Globe className="w-10 h-10 text-blue-500" />,
    title: "Global Reach",
    description: "Trusted Export Network",
  },
];

const Features = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-8 mt-10">
      {features.map((feature, index) => (
        <div
          key={index}
          className="flex flex-col items-center text-center space-y-2"
        >
          {feature.icon}
          <h3 className="text-lg font-semibold">{feature.title}</h3>
          <p className="text-sm text-gray-500">{feature.description}</p>
        </div>
      ))}
    </div>
  );
};

export default Features;
